var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "请选择",
      multiple: _vm.multiple
    },
    on: {
      change: _vm.selectApp
    },
    model: {
      value: _vm.coin_type,
      callback: function callback($$v) {
        _vm.coin_type = $$v;
      },
      expression: "coin_type"
    }
  }, _vm._l(_vm.coinList, function (item, i) {
    return _c("el-option", {
      key: i,
      attrs: {
        label: item,
        value: i
      }
    });
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };